import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import jwtService from 'app/services/jwtService';

function UserMenu(props) {
	const user = useSelector(({ auth }) => auth.user);

	const [userMenu, setUserMenu] = useState(null);

	const userMenuClick = event => {
		setUserMenu(event.currentTarget);
	};

	const userMenuClose = () => {
		setUserMenu(null);
	};

	return (
		<>
			<Button className="min-h-40 min-w-40 px-0 md:px-16 py-0 md:py-6" onClick={userMenuClick}>
				<div className="hidden md:flex flex-col mx-4 items-end">
					<Typography component="span" className="font-semibold flex">
						{user?.data?.displayName ?? ''}
					</Typography>
					<Typography className="text-11 font-medium capitalize" color="textSecondary">
						{user?.data?.nameCompany?.toString() ?? ''}
						<br></br>
						{user?.data?.companyRole?.toString() ?? ''}
					</Typography>
				</div>

				{user?.data?.photoURL ? (
					<Avatar className="md:mx-4" alt="user photo" src={user.data.photoURL} />
				) : (
					<Avatar className="md:mx-4">{user?.data?.displayName?.[0] ?? ''}</Avatar>
				)}
			</Button>

			<Popover
				open={Boolean(userMenu)}
				anchorEl={userMenu}
				onClose={userMenuClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				classes={{
					paper: 'py-8'
				}}
			>
				<MenuItem component={Link} to="/auth/my-profile" onClick={userMenuClose}>
					<ListItemIcon className="min-w-40">
						<FuseSvgIcon>account_circle</FuseSvgIcon>
					</ListItemIcon>
					<ListItemText primary="Mi perfil" />
				</MenuItem>
				{user.data.isActor !== 1 && (
					<MenuItem component={Link} to="/auth/change-password" onClick={userMenuClose}>
						<ListItemIcon className="min-w-40">
							<FuseSvgIcon>vpn_key</FuseSvgIcon>
						</ListItemIcon>
						<ListItemText primary="Cambiar contraseña" />
					</MenuItem>
				)}

				<MenuItem
					onClick={() => {
						jwtService.logout()
					}}
				>
					<ListItemIcon className="min-w-40">
						<FuseSvgIcon>exit_to_app</FuseSvgIcon>
					</ListItemIcon>
					<ListItemText primary="Cerrar sesion" />
				</MenuItem>
			</Popover>
		</>
	);
}

export default UserMenu;
